<!--Sección de preuntas frecuentes-->
<template>
    <v-expansion-panels accordion focusable>
        <v-expansion-panel v-for="item in questions" :key="item.id" >
            <v-expansion-panel-header class="title">{{ item.question }}</v-expansion-panel-header>
            <v-expansion-panel-content>
               <p class="mt-5 mb-0">
                    {{ item.answer }}
               </p>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
export default {
    /* 
    PROPIEDADES DEL COMPONENTE
    - questions - Arreglo de objetos con las siguientes propiedades: 
        1. question: String - Requerido - Una pregunta para la sección de FAQ de un evento
        2. answer: String - Requerido - la respuesta a la pregunta de la propiedad question     
    */
    props:{
        questions: { type: Array, required: true }
    }
}
</script>